module.exports = __webpack_public_path__ + "static/media/spray.e1707753.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/spray.svg
// module id = 605
// module chunks = 0